import React from 'react'

const UpcomingProjectPage = () => {
  return (
    <div>
        Upcoming Projecrs
    </div>
  )
}

export default UpcomingProjectPage